import { render, staticRenderFns } from "./releaseFeeDialog.vue?vue&type=template&id=53bbaffa&"
import script from "./releaseFeeDialog.vue?vue&type=script&lang=js&"
export * from "./releaseFeeDialog.vue?vue&type=script&lang=js&"
import style0 from "./releaseFeeDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports